import { Attribute, CustomAttributeRegistry, Input, Modifier } from '@rhtml/custom-attributes';

@Modifier({
  selector: 'parallaxx',
  registry(this: HTMLElement) {
    return new CustomAttributeRegistry(this);
  },
})
export class Parallax extends Attribute {
  @Input({ observe: true })
  speed = '0.5';

  @Input({ observe: true })
  direction = 'up'; // 'up', 'down', 'left', 'right'

  private ticking = false;
  private currentY = 0;
  private currentX = 0;
  private boundHandleScroll: () => void;

  OnInit() {
    console.log('Parallax: OnInit called with speed:', this.speed, 'direction:', this.direction);
    this.boundHandleScroll = this.handleScroll.bind(this);
    this.setupParallax();
  }

  OnDestroy() {
    window.removeEventListener('scroll', this.boundHandleScroll);
  }

  OnUpdate() {
    // Recalculate position when attributes change
    this.updatePosition();
  }

  private setupParallax() {
    // Set initial styles
    this.element.style.transform = 'translateZ(0)';
    this.element.style.willChange = 'transform';

    // Add scroll listener
    window.addEventListener('scroll', this.boundHandleScroll);

    // Initial position update
    this.updatePosition();
    console.log('Parallax: Setup complete');
  }

  private handleScroll = () => {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.updatePosition();
        this.ticking = false;
      });
      this.ticking = true;
    }
  };

  private updatePosition() {
    const speed = parseFloat(this.speed) || 0.5;
    const direction = this.direction || 'up';

    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;

    // Calculate how much of the element is visible
    const elementTop = rect.top;
    const elementHeight = rect.height;
    const elementLeft = rect.left;
    const elementWidth = rect.width;

    // Calculate progress (0 to 1) based on element position
    let progress = 0;

    if (direction === 'up' || direction === 'down') {
      progress = (windowHeight - elementTop) / (windowHeight + elementHeight);
    } else {
      progress = (windowWidth - elementLeft) / (windowWidth + elementWidth);
    }

    progress = Math.max(0, Math.min(1, progress));

    // Calculate transform based on direction and speed
    let transform = '';

    switch (direction) {
      case 'up':
        transform = `translateY(${progress * speed * 100}px)`;
        break;
      case 'down':
        transform = `translateY(${-progress * speed * 100}px)`;
        break;
      case 'left':
        transform = `translateX(${progress * speed * 100}px)`;
        break;
      case 'right':
        transform = `translateX(${-progress * speed * 100}px)`;
        break;
      default:
        transform = `translateY(${progress * speed * 100}px)`;
    }

    this.element.style.transform = `translateZ(0) ${transform}`;
    console.log('Parallax: Updated position - progress:', progress.toFixed(2), 'transform:', transform);
  }
}
